import React, { Fragment, } from "react"
import { Zoom, } from 'react-slideshow-image'

import screen1BackgroundImage from "../../assets/images/featureSlideShow/screen1/background-image.png"
import screen1FeatureImage from "../../assets/images/featureSlideShow/screen1/feature-image.png"
import screen1HeaderText from "../../assets/images/featureSlideShow/screen1/header-text.png"
import screen1SubHeaderText from "../../assets/images/featureSlideShow/screen1/sub-header-text.png"
import screen1LeftBottomBar from "../../assets/images/featureSlideShow/screen1/left-bottom-bar.png"
import screen1TopRightBar from "../../assets/images/featureSlideShow/screen1/top-right-bar.png"

import screen2BackgroundImage from "../../assets/images/featureSlideShow/screen2/background-image.png"
import screen2FeatureImage from "../../assets/images/featureSlideShow/screen2/feature-image.png"
import screen2HeaderText from "../../assets/images/featureSlideShow/screen2/header-text.png"
import screen2SubHeaderText from "../../assets/images/featureSlideShow/screen2/sub-header-text.png"
import screen2LeftBottomBar from "../../assets/images/featureSlideShow/screen2/left-bottom-bar.png"
import screen2TopRightBar from "../../assets/images/featureSlideShow/screen2/top-right-bar.png"

import screen3BackgroundImage from "../../assets/images/featureSlideShow/screen3/background-image.png"
import screen3FeatureImage from "../../assets/images/featureSlideShow/screen3/feature-image.png"
import screen3HeaderText from "../../assets/images/featureSlideShow/screen3/header-text.png"
import screen3SubHeaderText from "../../assets/images/featureSlideShow/screen3/sub-header-text.png"
import screen3LeftBottomBar from "../../assets/images/featureSlideShow/screen3/left-bottom-bar.png"
import screen3TopRightBar from "../../assets/images/featureSlideShow/screen3/top-right-bar.png"

import "./FeatureSlideshow.scss"

const slideImages = [
  {
    backgroundImage: screen1BackgroundImage,
    featureImage: screen1FeatureImage,
    headerText: screen1HeaderText,
    leftBottomBar: screen1LeftBottomBar,
    subHeaderText: screen1SubHeaderText,
    topRightBar: screen1TopRightBar,
  },
  {
    backgroundImage: screen2BackgroundImage,
    featureImage: screen2FeatureImage,
    headerText: screen2HeaderText,
    leftBottomBar: screen2LeftBottomBar,
    subHeaderText: screen2SubHeaderText,
    topRightBar: screen2TopRightBar,
  },
  {
    backgroundImage: screen3BackgroundImage,
    featureImage: screen3FeatureImage,
    headerText: screen3HeaderText,
    leftBottomBar: screen3LeftBottomBar,
    subHeaderText: screen3SubHeaderText,
    topRightBar: screen3TopRightBar,
  },
]

const indicators = (index) => {
  return (
    <div className="indicator"></div>
  )
}

const FeatureSlideshow = () => {
  return (
    <div className="feature-slide-container">
      <Zoom scale={1.4} indicators={indicators}>
        {slideImages.map((slideImage, index)=> (
          <div key={index}>
            <div className="feature-slide-top-right-bar-container">
              <img className="feature-slide-top-right-bar" src={slideImage.topRightBar} />
            </div>
            <div className="feature-slide-div" style={{ 'backgroundImage': `url(${slideImage.backgroundImage})` }}>
              <div className="feature-slide-image-container">
                <img 
                  src={slideImage.featureImage} 
                  alt="Feature Image" 
                  className="feature-slide-image"
                />
              </div>
              <div className="feature-slide-text-container">
                <img className="feature-slide-header-text" src={slideImage.headerText} />
                <img className="feature-slide-sub-header-text" src={slideImage.subHeaderText} />
              </div>
            </div>
            <div className="feature-slide-left-bottom-bar-container">
              <img className="feature-slide-left-bottom-bar" src={slideImage.leftBottomBar} />
            </div>
          </div>
        ))} 
      </Zoom>
    </div>
  )
}

export default FeatureSlideshow